import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { FinancialCardAbuseModel } from './types';
import financialCardAbuseItemValidator from './validators/item';

const financialCardAbuseValidator: ValidateJSModel<FinancialCardAbuseModel> = {
  HasCardAbuse: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasCardAbuse?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialCardAbuseItemValidator },
      };
    }

    return {};
  },
};

export default financialCardAbuseValidator;
